import {Injectable} from '@angular/core';
import {BaseContextBar} from '../base-context-bar';
import {ContextBarOptionGroup} from '@q9elements/ui-kit/components';
import {menuItems} from '../../context-menu/menu-items';
import {SelectionTypes} from 'src/app/shared/models/diagram-interactions.interface';

@Injectable()
export class ActivityContextBar extends BaseContextBar {
  public selectionType = SelectionTypes.Activity;

  public getOptions(): ContextBarOptionGroup[] | null {
    if (!this.registry.getGraph().isEnabled()) {
      return null;
    }

    switch (true) {
      case this.isSelected.one:
        return this.singleSelectionOptions;

      case this.isSelected.some:
        return this.multiSelectionOptions;
    }
  }

  private get singleSelectionOptions() {
    return [
      [
        this.createMenuItemOption(menuItems.addDocumentation),
        this.createMenuItemOption(menuItems.addChange),
        this.createMenuItemOption(menuItems.generate),
        this.createMenuItemOption(menuItems.addToCard),
        this.createMenuItemOption(menuItems.renumberActivity)
      ],
      [this.createMenuItemOption(menuItems.drilldown)],
      [this.createMenuItemOption(menuItems.theme)],
      [this.createMenuItemOption(menuItems.copy), this.createMenuItemOption(menuItems.delete)]
    ];
  }

  private get multiSelectionOptions() {
    return [
      [
        this.createMenuItemOption(menuItems.generate),
        this.createMenuItemOption(menuItems.addToCard)
      ],
      [
        this.createMenuItemOption(menuItems.align),
        this.createMenuItemOption(menuItems.distribute),
        this.createMenuItemOption(menuItems.matchSize)
      ],
      [this.createMenuItemOption(menuItems.themePasteMenu)],
      [this.createMenuItemOption(menuItems.copy), this.createMenuItemOption(menuItems.delete)]
    ];
  }
}
